module.exports = __webpack_public_path__ + "img/wps1.01537b8c.png";